import { Box, Typography } from '@mui/material';
import React from 'react';

type InfoBoxProps = {
  title: string;
  description: string;
};

export const InfoBox: React.FC<InfoBoxProps> = ({ title, description }) => {
  return (
    <Box>
      <Typography variant="h5" sx={{
        fontWeight: 300
      }}>
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 300,
          color: "#1B3D5599",
          fontSize: 14
        }}>
        {description}
      </Typography>
    </Box>
  );
};
